module.exports = __webpack_public_path__ + "static/media/iconAlert_delete.feef4de3.svg";